import styled, { ThemeProvider } from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Collection from '../Collection'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const theme = {
    backgroundColor: colorMode === 'dark' ? '#202346' : '#ffe462',
    paginationLineContent: colorMode === 'dark' ? '#B3A798' : '#013f2133',
    mainColor: colorMode === 'dark' ? '#f1e2ce' : '#013f21', // vert (dark mode: jaune)
    lightYellow: '#f1e2ce',
    lighterYellow: '#FFEED9',
    secondaryColor: '#e59175', // orange
    tenant: tenant,
    darkMode: colorMode === 'dark',
  }

  return (
    <AppContainer colorMode={colorMode}>
      <ThemeProvider theme={theme}>
        <Collection colorMode={colorMode} />
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(GlobalVariables)`
  font-family: var(--font-plex);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
